export default "__VITE_ASSET__9e6354a0__"